import React, { useEffect, useState } from 'react';
import cookie from 'cookie';
import { useSelector } from 'react-redux';

import { CookiePolicy } from 'components/CookiePolicy';
import { getCurrentGeolocation } from 'src/api/customerApi';
import { getCookieByName } from 'lib/storage.service';
import { IS_ACCEPTED_COOKIE, SESSION_COOKIE_NAME } from 'constants/constants';
import { Store } from 'app-redux/types/storeTypes';
import { CookiePolicyContainerInterface } from 'components/CookiePolicy/declarations';
import { Logger } from 'lib/logger';

const IS_SEEN_BANNER_COOKIE_NAME = encodeURIComponent(IS_ACCEPTED_COOKIE);
const CookiePolicyContainer: React.FC<CookiePolicyContainerInterface> = ({
  isStickyOfferExists,
  cookiePolicy,
}) => {
  const isAuthenticated = useSelector((store: Store) => store.server.auth.isAuthenticated);
  const [isEuropeanCustomer, setEuropeanCustomerFlagState] = useState<boolean>(false);
  const [isAccepted, setAcceptedState] = useState<boolean>(
    !!getCookieByName(IS_SEEN_BANNER_COOKIE_NAME),
  );

  const acceptCookies = () => {
    document.cookie = `${IS_SEEN_BANNER_COOKIE_NAME}=${encodeURIComponent(true)}; expires=expires=Fri, 31 Dec 2030 23:59:59 GMT`;
    setAcceptedState(true);
  };

  const checkNeedCancelCookieAndStopMethod = (condition: boolean, cookies: any): boolean => {
    const isAcceptedCookie = cookies[IS_ACCEPTED_COOKIE];

    if (condition) {
      if (!isAcceptedCookie) {
        return true;
      }

      setEuropeanCustomerFlagState(false);
      cookie.serialize(IS_ACCEPTED_COOKIE, '', { maxAge: 0 });

      return true;
    }

    return false;
  };

  useEffect(() => {
    (async () => {
      if (!isAccepted && isAuthenticated) {
        try {
          const cookies = cookie.parse(document.cookie);
          const auth = cookies[SESSION_COOKIE_NAME];

          if (checkNeedCancelCookieAndStopMethod(!auth, cookies)) {
            return;
          }

          const data = await getCurrentGeolocation();
          setEuropeanCustomerFlagState(data.isInEuropeanUnion);
        } catch (e) {
          Logger.error(e);
        }
      }
    })();
  }, [isAccepted, isAuthenticated]);

  if (!isEuropeanCustomer || isAccepted) return null;

  return (
    <CookiePolicy
      isStickyOfferExists={isStickyOfferExists}
      cookiePolicy={cookiePolicy}
      acceptCookies={acceptCookies}
    />
  );
};

export default CookiePolicyContainer;
